<script setup lang="ts">
import AppNavigation from '@/ui-kit/layout/AppNavigation.vue'

function goBack() {
  window.history.back()
}
</script>

<template>
  <div class="account-frame">
    <AppNavigation role="teacher" />
    <div class="requires-auth requires-auth_user content">
      <notifications position="bottom right" />
      <v-unauthorized-card level="user" title="Недоступно" />
      <v-button mode="primary large flat" class="mt-1" @click="goBack"> Вернуться назад </v-button>
    </div>
  </div>
</template>

<style lang="scss">
@use '@/styles/pages/users/unauthorized.scss' as *;
</style>
